import {Colors} from 'appearance'
import {useI18n, useIsRtl} from 'store/Store'
import Button from 'components/Control/Button'
import Notification from './Notification'
import {Divider, Menu, styled, Typography} from '@mui/material'
import {notifications} from 'mockdata'

const MenuListProps = {
    style: {
        width: 315,
        height: 280,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
}

const NotificationsMenu = ({menuId, anchorEl, isMenuOpen, handleCloseMenu}) => {
    const {i18n} = useI18n()
    const isRtl = useIsRtl()

    return (
        <Menu
            dir={isRtl ? 'rtl' : 'ltr'}
            MenuListProps={MenuListProps}
            anchorEl={anchorEl}
            id={menuId}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={isMenuOpen('notifications')}
            onClose={handleCloseMenu('notifications')}
            onClick={handleCloseMenu('notifications')}>
            <MenuTitle>
                {i18n.t('notificationsMenu.notifications')}
                <NotificationsCount>24</NotificationsCount>
            </MenuTitle>
            <Divider />
            <NotificationsList>
                {notifications.map((notification, i) => (
                    <Notification
                        key={`notification_${i}]`}
                        notification={notification}
                        onClick={handleCloseMenu('notifications')}
                    />
                ))}
            </NotificationsList>
            <Button fullWidth>
                <RemoveAllNotificationButtonText>
                    {i18n.t('notificationsMenu.removeNotifications')}
                </RemoveAllNotificationButtonText>
            </Button>
        </Menu>
    )
}

export default NotificationsMenu

const MenuTitle = styled(Typography)`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
`

const NotificationsList = styled('div')`
    height: 160px;
    overflow: auto;
    padding: 8px;
`

const NotificationsCount = styled(Typography)`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${Colors.NOTIFICATIONS_BADGE};
    width: 30px;
    height: 30px;
    border-radius: 50px;
    font-size: 15px;
    font-weight: 700;
    color: ${Colors.APP_WHITE};
`
const RemoveAllNotificationButtonText = styled(Typography)`
    color: ${Colors.GRAY_BUTTON_TEXT};
`
